<template>
  <div
    class="bottom-modal"
    :class="{
      'bottom-modal-autoheight': dataAutoHeight
    }"
  >
    <transition name="fade">
      <div class="mask" v-show="showMask || dataShowIndex" @click="close"></div>
    </transition>
    
    <transition name="up">
      <div class="bottom-modal-inner" v-show="dataShowIndex">
        <div
          class="bottom-modal-items"
          :style="{
            width: `${width}px`,
            transform: `translate3d(${transformWidth}px, 0, 0)`
          }"
        >
          <slot></slot>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    showMask: {
      type: Boolean,
      default: false
    },
    showIndex: {
      type: Number,
      default: 0
    },
    autoHeight: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dataShowIndex: this.showIndex,
      windowWidth: document.body.offsetWidth,
      transformWidth: null,
      width: null,
      dataAutoHeight: this.autoHeight
    };
  },
  watch: {
    showIndex(val) {
      this.dataShowIndex = val;
    },
    dataShowIndex(val) {
      this.$emit("update:showIndex", val);

      if (val) {
        document.body.style.position = "fixed";
        document.body.style.overflow = "hidden";
        this.transformWidth = -this.windowWidth * (val - 1);
      } else {
        document.body.style.position = "";
        document.body.style.overflow = "";
      }
    }
  },
  methods: {
    close() {
      this.dataShowIndex = 0;
    },
    back() {
      this.dataShowIndex--;
    }
  },
  mounted() {
    this.$on('close', this.close);
    this.width = this.windowWidth * this.$children.length;
  },
  beforeDestroy() {
    document.body.style.position = "";
    document.body.style.overflow = "";
  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/px2rem.scss";

.bottom-modal {
  &.bottom-modal-autoheight {
    .bottom-modal-inner {
      height: auto;
      .bottom-modal-items {
        height: auto;
      }
    }
  }

  .mask {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
    background-color: #000;
    opacity: 0.5;
  }

  .bottom-modal-inner {
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 10;
    height: 80%;
    .bottom-modal-items {
      height: 100%;
    }
    .bottom-modal-items {
      transition: transform 0.3s;
    }
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.3s;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
  .up-enter-active,
  .up-leave-active {
    transition: transform 0.3s;
  }
  .up-enter,
  .up-leave-to {
    transform: translate3d(0, 100%, 0);
  }
}
</style>
